import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

import { MIN_ROW_HEIGHT } from '@web/shiftTasks/ComposeTask/constants';

export const SubtaskContainer = styled(Row)`
  align-items: center;
  gap: 10px;
  height: ${MIN_ROW_HEIGHT}px;
`;

type SubtasksContainerProps = {
  isDisabled?: boolean;
};

export const SubtasksContainer = styled.div<SubtasksContainerProps>`
  opacity: ${({ isDisabled }) => (isDisabled ? '.65' : 1)};
`;
